import {
  FlexRow,
  SvgIcon,
  ValidatorStatusActiveIcon,
  ValidatorStatusInactiveBidIcon,
  ValidatorStatusTriesIcon,
  ValidatorStatusWasIcon,
  ValidatorStatusWillBeIcon,
} from '@make-software/cspr-design';
import { BodyText } from '@block-explorer/ui';
import React from 'react';
import { ValidatorType } from '../hooks/use-get-validator-account-details-hook';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const ValidatorTypeIconStyle: Record<string, { icon: string; color: string }> =
  {
    [ValidatorType.ACTIVE_VALIDATOR]: {
      icon: ValidatorStatusActiveIcon,
      color: 'contentGreen',
    },
    [ValidatorType.PAST_VALIDATOR]: {
      icon: ValidatorStatusWasIcon,
      color: 'contentTertiary',
    },
    [ValidatorType.ACTIVE_VALIDATOR_BID]: {
      icon: ValidatorStatusTriesIcon,
      color: 'contentGreen',
    },
    [ValidatorType.INACTIVE_VALIDATOR_BID]: {
      icon: ValidatorStatusInactiveBidIcon,
      color: 'contentTertiary',
    },
    [ValidatorType.PENDING_VALIDATOR]: {
      icon: ValidatorStatusWillBeIcon,
      color: 'contentTertiary',
    },
  };

const IconWrapper = styled.span<{ color: string }>(({ theme, color }) => ({
  color: theme.styleguideColors[color],
}));

export const AccountValidatorType = ({ status }) => {
  const { t } = useTranslation();

  const validatorTypeStatusLabel = {
    [ValidatorType.ACTIVE_VALIDATOR]: t('Active Validator'),
    [ValidatorType.PAST_VALIDATOR]: t('Past Validator'),
    [ValidatorType.PENDING_VALIDATOR]: t('Pending Validator'),
    [ValidatorType.ACTIVE_VALIDATOR_BID]: t('Active Validator Bid'),
    [ValidatorType.INACTIVE_VALIDATOR_BID]: t('Inactive Validator Bid'),
  };

  return (
    <FlexRow align={'center'} justify={'left'} itemsSpacing={10}>
      <IconWrapper color={ValidatorTypeIconStyle[status].color}>
        <SvgIcon
          src={ValidatorTypeIconStyle[status].icon}
          role={'img'}
          alt={'Validator status icon'}
        />
      </IconWrapper>
      <BodyText scale={'sm'} size={3}>
        {validatorTypeStatusLabel[status]}
      </BodyText>
    </FlexRow>
  );
};
